import { P } from 'components'
import PMBModalImagePreview from 'components/PMBModalImagePreview'
import SidebarDetails from 'components/SidebarDetails'
import { STATUS_TYPE } from 'constants'
import { getTimelineItem } from 'helpers'
import { useState } from 'react'
import { Card, CardText } from 'reactstrap'
import { formatDatePMBV2 } from 'utils/formatDate'

const VesselNotFound = '/assets/no-image.svg'

const SidebarDetailWhistleBlowing = ({
  isOpenSidebar,
  onHandleOpenCloseSidebar,
  detailRow,
}) => {
  const [modalOpenImage, setModalOpenImage] = useState(false)
  const [images, setImages] = useState([])

  // HANDLE NOTE BASED ON STATUS TYPE
  const NoteColumn = ({ row }) => {
    const getNote = (row) => {
      switch (row?.status) {
        case STATUS_TYPE.ASSIGNED:
          return row?.assignNotes ?? '-'
        case STATUS_TYPE.RESOLVED:
          return row?.resolveNotes ?? '-'
        case STATUS_TYPE.UNRESOLVED:
          return row?.unresolveNotes ?? '-'
        default:
          return '-'
      }
    }

    return <span>{getNote(row)}</span>
  }

  return (
    <>
      <PMBModalImagePreview
        isOpen={modalOpenImage}
        toggle={() => setModalOpenImage(!modalOpenImage)}
        images={images}
      />
      {/* SIDEBAR DETAIL */}
      <SidebarDetails
        size="lg"
        open={isOpenSidebar}
        title="Detail Pengaduan"
        headerClassName="mb-1"
        contentClassName="pt-0"
        toggleSidebar={() => {
          onHandleOpenCloseSidebar()
        }}
        style={{
          backgroundColor: 'white',
        }}
      >
        <>
          <div
            body
            className="mb-3 mt-3"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CardText tag="h5" className="fw-semibold">
              {detailRow?.name ?? '-'}
            </CardText>
          </div>
          <Card
            body
            className={`mb-3 border-0 shadow-sm ${
              detailRow?.status === STATUS_TYPE?.RESOLVED
                ? 'bg-success-50'
                : 'bg-primary-50'
            } ${
              detailRow?.status === STATUS_TYPE?.RESOLVED
                ? 'text-success-700'
                : 'text-primary'
            }`}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div>
              <CardText tag="h6" className="fw-semibold">
                {detailRow?.status === STATUS_TYPE?.RESOLVED
                  ? detailRow?.status
                  : 'OPEN'}
              </CardText>
            </div>
          </Card>
          <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Nama Pelapor
              </CardText>
              <p className="m-0">{detailRow?.user?.name ?? '-'}</p>
            </div>
          </Card>
          <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Laporan Diterima
              </CardText>
              <p className="m-0">{formatDatePMBV2(detailRow?.createdAt)}</p>
            </div>
          </Card>
          {detailRow?.status === STATUS_TYPE?.RESOLVED && (
            <Card body className="mb-3 mt-3 border-0 shadow-sm">
              <div>
                <CardText tag="h6" className="fw-semibold">
                  Laporan Selesai
                </CardText>
                <p className="m-0">{formatDatePMBV2(detailRow?.updatedAt)}</p>
              </div>
            </Card>
          )}
          <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Deskripsi
              </CardText>

              {detailRow?.lastMessageReceived ? (
                <div
                  style={{
                    maxHeight: '300px',
                    overflowY: 'auto',
                    padding: '10px',
                    borderRadius: '8px',
                  }}
                >
                  {(detailRow?.description ?? '')
                    .split('\n\n')
                    .filter((msg) => msg.trim() !== '')
                    .map((msg, index) => {
                      const regex =
                        /\[(?<datetime>[^\]]+)\]\s*(?<phone>[^\[\]:]+?)\s*(?:\[staf\])?\s*[:]?[\s]*\[(?<message>[^\]]*)\]/
                      const match = msg.match(regex)

                      if (!match) return null

                      const { datetime, phone, message } = match.groups
                      let text = message.trim()
                      const isStaff = msg.includes('[staf]')

                      if (!text) return null

                      const hasImage = text.toLowerCase().includes('image/jpeg')
                      if (hasImage) {
                        const textOnly = text
                          .replace(/\(image\/jpeg\)/i, '')
                          .trim()
                        text = textOnly ? `${textOnly} (GAMBAR)` : '(GAMBAR)'
                      }

                      return (
                        <div
                          key={index}
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: isStaff ? 'flex-start' : 'flex-end',
                            marginBottom: '10px',
                          }}
                        >
                          <small
                            style={{
                              fontSize: '0.75rem',
                              color: '#6c757d',
                              marginBottom: '2px',
                            }}
                          >
                            {phone
                              ? `${datetime} ${phone}${isStaff ? ' (staf)' : ''}`
                              : datetime}
                          </small>

                          <div
                            style={{
                              backgroundColor: isStaff ? '#e9ecef' : '#d1e7dd',
                              color: '#000',
                              padding: '8px 12px',
                              borderRadius: '12px',
                              maxWidth: '75%',
                              whiteSpace: 'pre-line',
                              textAlign: 'left',
                            }}
                          >
                            {text}
                          </div>
                        </div>
                      )
                    })}
                </div>
              ) : (
                <span>{detailRow?.description ?? '-'}</span>
              )}
            </div>
          </Card>

          <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Petugas
              </CardText>
              <p className="m-0">{detailRow?.assigned?.name ?? '-'}</p>
            </div>
          </Card>
          <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Catatan
              </CardText>
              <p className="m-0">{<NoteColumn row={detailRow} />}</p>
            </div>
          </Card>
          <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Bukti Kejadian{' '}
                {detailRow?.lastMessageReceived ? 'Pengguna' : ''}
              </CardText>

              <PMBModalImagePreview
                isModal={false}
                images={
                  detailRow?.linksImage
                    ? detailRow?.linksImage.split(',').map((url) => url.trim())
                    : [VesselNotFound]
                }
                onClick={() => {
                  setModalOpenImage(true)
                  setImages(
                    detailRow?.linksImage
                      ? detailRow?.linksImage
                          .split(',')
                          .map((url) => url.trim())
                      : [VesselNotFound],
                  )
                }}
              />
            </div>
          </Card>
          {detailRow?.lastMessageReceived ? (
            <>
              {' '}
              <Card body className="mb-3 mt-3 border-0 shadow-sm">
                <div>
                  <CardText tag="h6" className="fw-semibold">
                    Bukti Kejadian Staf
                  </CardText>
                  <PMBModalImagePreview
                    isModal={false}
                    images={
                      detailRow?.linksImageReply
                        ? detailRow?.linksImageReply
                            .split(',')
                            .map((url) => url.trim())
                        : [VesselNotFound]
                    }
                    onClick={() => {
                      setModalOpenImage(true)
                      setImages(
                        detailRow?.linksImageReply
                          ? detailRow?.linksImageReply
                              .split(',')
                              .map((url) => url.trim())
                          : [VesselNotFound],
                      )
                    }}
                  />
                </div>
              </Card>
            </>
          ) : (
            <></>
          )}
        </>
      </SidebarDetails>
    </>
  )
}

export default SidebarDetailWhistleBlowing
